import * as React from "react";
import styled, { css } from "styled-components";
const StyledSlide = styled.div(
  ({ $size, $gap, theme }) => css`
    flex: 0 0 ${$size != null ? $size : "24%"};
    min-width: 0;
    min-height: 100px;
    margin-right: ${$gap != null ? $gap : theme.spacings.sm};
    position: relative;
  `
);
const CarouselSlide = ({
  children = void 0,
  size = void 0,
  gap = void 0,
  className = void 0
}) => /* @__PURE__ */ React.createElement(StyledSlide, { $size: size, $gap: gap, className }, children);
export default CarouselSlide;
